import { inject, Injectable } from '@angular/core';
import { marker } from '@jsverse/transloco-keys-manager/marker';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { get } from 'lodash-es';
import { of as observableOf } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { SharedService } from '../../../core/services/shared.service';
import {
  enqueueErrorSnackbar,
  enqueueInfoSnackbar,
  enqueueSuccessSnackbar,
} from '../actions/enqueue-snackbar.actions';
import {
  showFailMessage,
  showImportSuccessMessage,
  showSuccessMessage,
  showUnauthorizedMessage,
} from '../actions/show-message.actions';

@Injectable()
export class ShowMessageEffect {
  readonly #actions$ = inject(Actions);
  readonly #sharedService = inject(SharedService);

  readonly enqueueSuccessSnackbar$ = createEffect(() => {
    return this.#actions$.pipe(
      ofType(showSuccessMessage),
      map((action) => action.payload),
      switchMap((data) =>
        observableOf(
          enqueueSuccessSnackbar({
            configuration: {
              translationKey: this.#sharedService.getSuccessMessage(
                // @ts-expect-error TODO: delete the comment and fix the error
                data,
              ),
            },
          }),
        ),
      ),
    );
  });

  readonly enqueueErrorSnackbar$ = createEffect(() => {
    return this.#actions$.pipe(
      ofType(showFailMessage),
      map((action) => action.payload),
      filter((data) => get(data, ['payload', 'status']) !== 401),
      switchMap((data) =>
        observableOf(
          enqueueErrorSnackbar({
            configuration: {
              translationKey: this.#sharedService.getErrorMessage(data),
            },
          }),
        ),
      ),
    );
  });

  readonly showUnauthorizedMessage$ = createEffect(() => {
    return this.#actions$.pipe(
      ofType(showUnauthorizedMessage),
      switchMap(() =>
        observableOf(
          enqueueErrorSnackbar({
            configuration: {
              translationKey: marker('shared.tokenExpired'),
              // TODO: move to a constant
              priority: 100_000,
            },
          }),
        ),
      ),
    );
  });

  readonly showImportMessage$ = createEffect(() => {
    return this.#actions$.pipe(
      ofType(showImportSuccessMessage),
      switchMap(() =>
        observableOf(
          enqueueInfoSnackbar({
            configuration: {
              translationKey: marker('shared.importMessage'),
            },
          }),
        ),
      ),
    );
  });
}
